import Framework, { BaseService } from '@greenville/framework';
import * as constants from '../../../common/constants';
import utils from '../../../common/utils';

export default class TrendingTopicsService extends BaseService {
  constructor() {
    super(constants.GET_TRENDING_TOPICS_MODEL_DATA, 'TrendingTopicsStatus');
  }

  handleEvent(eventName, event) {
    return this.getClient('aiadmin').post(`/gettopuserinputs`, event.payload);
  }

  handleResponse(response) {
    const { data, status } = response;
    if (status === 200 && data.data.length > 0) {
      Framework.getStoreRegistry().getStore('trendingTopics').setResponse(response.data);
    } else {
      const notification = {
        open: true,
        type: 'error',
        message: 'Data Not Found'
      };
      Framework.getStoreRegistry().getStore('notificationState').set(notification);
    }
  }

  handleError(error) {
    // eslint-disable-line class-methods-use-this
    const { response } = error;
    if (response) {
      const { status, data } = response;
      if (status === 401) {
        utils.redirectToLogin();
      }
      if (status === 500 && data && data.error) {
        const notification = {
          open: true,
          message: data.error.message,
          type: 'error'
        };
        Framework.getStoreRegistry().getStore('notificationState').set(notification);
      }
    }
  }
}
